export const IconCalendar = (props: IconClip) => {
	return (
		<svg
			width={props.width ?? 16}
			height={props.height ?? 16}
			viewBox="0 0 24 24"
			fill="none"
			stroke={props.color ?? "#d9dfe9"} // подстава блятЬ!
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
			<line x1="16" y1="2" x2="16" y2="6" />
			<line x1="8" y1="2" x2="8" y2="6" />
			<line x1="3" y1="10" x2="21" y2="10" />
		</svg>
	);
};
